import React from 'react';
import PropTypes from 'prop-types';
import './DivLayoutV2.css';

const DivLayoutV2Block = ({ title, children, className = '' }) => (
  <div className={`div-layout-v2-block ${className}`.trim()}>
    {title && <h3 className="div-layout-v2-block-title">{title}</h3>}
    <div className="div-layout-v2-block-content">{children}</div>
  </div>
);

DivLayoutV2Block.propTypes = {
  title: PropTypes.string,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
};

export default DivLayoutV2Block;
